<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-04-02 18:16:38
-->

<template>
  <div class="pie">
    <div class="title">
      <span>校园餐产品销售统计</span>
    </div>
    <vue-seamless-scroll :data="data" :class-option="scrollOption" class="progress-list">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="progress-item"
        :style="{ animationDelay: `${index * 0.08}s` }"
      >
        <div class="content-wrapper">
          <div class="info-row">
            <div class="name">{{ item.materialName }}</div>
            <div class="price">
              <span class="price-value">{{ formatNumber(item.sumCkPutTotalPrice) }}</span>
              <span class="price-unit">万元</span>
            </div>
          </div>
          <div class="progress-wrapper">
            <div class="progress-track">
              <div
                class="progress-bar"
                :style="{
                  width: `${(item.sumCkPutTotalPrice / max) * 100}%`,
                  background: getGradient(index),
                  boxShadow: getGlow(index),
                }"
              >
                <div class="progress-shine"></div>
                <div class="progress-tip"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { materialSalePricePage } from '@/api/dashboard'
import to from 'await-to'

const colorMap = [
  { start: '#FF6B6B', end: '#FF8E53', glow: 'rgba(255, 107, 107, 0.6)' },
  { start: '#4ECDC4', end: '#44A08D', glow: 'rgba(78, 205, 196, 0.6)' },
  { start: '#667EEA', end: '#764BA2', glow: 'rgba(102, 126, 234, 0.6)' },
  { start: '#F093FB', end: '#F5576C', glow: 'rgba(240, 147, 251, 0.6)' },
  { start: '#4FACFE', end: '#00F2FE', glow: 'rgba(79, 172, 254, 0.6)' },
  { start: '#43E97B', end: '#38F9D7', glow: 'rgba(67, 233, 123, 0.6)' },
  { start: '#FA709A', end: '#FEE140', glow: 'rgba(250, 112, 154, 0.6)' },
  { start: '#30CFD0', end: '#330867', glow: 'rgba(48, 207, 208, 0.6)' },
]

export default {
  data() {
    return {
      type: 3,
      max: 92562,
      scrollOption: {
        step: 0.6,
        limitMoveNum: 4,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0,
      },
      data: [],
    }
  },
  mounted() {
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(
        materialSalePricePage({
          type: this.type,
          size: 30,
        }),
      )
      if (err) return
      this.data = res.data.list
      this.max = Math.max(...res.data.list.map(item => item.sumCkPutTotalPrice))
    },
    getGradient(index) {
      const colorIndex = Math.floor(Math.abs(index) % colorMap.length)
      const color = colorMap[colorIndex]
      return `linear-gradient(90deg, ${color.start} 0%, ${color.end} 100%)`
    },
    getGlow(index) {
      const colorIndex = Math.floor(Math.abs(index) % colorMap.length)
      const color = colorMap[colorIndex]
      return `0 0 10px ${color.glow}, 0 0 20px ${color.glow}`
    },
    formatNumber(num) {
      if (!num) return '0.00'
      return parseFloat(num).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    typeChange(type) {
      this.type = type
      this.initData()
    },
  },
}
</script>

<style lang="scss" scoped>
.pie {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  .title {
    position: relative;
    width: 100%;
    height: 70px;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 70px;
    padding-left: 47px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .unit {
    font-size: 20px;
    position: absolute;
    right: 30px;
    top: 30px;
    color: #ecf8ff;
  }

  .progress-list {
    height: calc(100% - 70px);
    overflow: hidden;
    padding: 14px;

    .progress-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 7px 16px;
      background: url('~@/img/agriculture/school_card_bg.png') 100% 100%;
      border: 1px solid rgba(255, 255, 255, 0.08);
      // backdrop-filter: blur(10px);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      animation: slideInUp 0.6s ease-out forwards;
      opacity: 0;
      transform: translateY(20px);

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.1) 0%,
          rgba(255, 255, 255, 0.05) 100%
        );
        border-color: rgba(255, 255, 255, 0.2);
        transform: translateX(4px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3), 0 0 30px rgba(100, 200, 255, 0.1);
      }

      .content-wrapper {
        flex: 1;
        min-width: 0;

        .info-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .name {
            font-size: 18px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.9);
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 16px;
          }

          .price {
            display: flex;
            align-items: baseline;
            flex-shrink: 0;

            color: #99e3d1;
            .price-value {
              font-size: 18px;
              font-weight: 700;
            }

            .price-unit {
              font-size: 12px;
            }
          }
        }

        .progress-wrapper {
          display: flex;
          align-items: center;
          gap: 12px;

          .progress-track {
            flex: 1;
            height: 12px;
            background: rgba(255, 255, 255, 0.08);
            border-radius: 6px;
            overflow: hidden;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              inset: 0;
              background: linear-gradient(
                90deg,
                transparent 0%,
                rgba(255, 255, 255, 0.1) 50%,
                transparent 100%
              );
              animation: shimmer 2s infinite;
            }

            .progress-bar {
              height: 100%;
              border-radius: 6px;
              position: relative;
              transition: width 1s cubic-bezier(0.4, 0, 0.2, 1);
              animation: progressGrow 1s ease-out forwards;

              .progress-shine {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 50%;
                background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 100%);
                border-radius: 6px 6px 0 0;
              }

              .progress-tip {
                position: absolute;
                right: -3px;
                top: 50%;
                transform: translateY(-50%);
                width: 6px;
                height: 18px;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 3px;
                box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
              }
            }
          }

          .percent {
            font-size: 12px;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.5);
            min-width: 42px;
            text-align: right;
          }
        }
      }
    }
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes progressGrow {
  from {
    width: 0 !important;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
</style>
